import { h } from 'preact';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Skeleton from '@mui/material/Skeleton';

export default function LazyDifferenceCard(props) {
  const { title, outlined } = props;

  const styles = {};

  if (!outlined) {
    styles.border = 'none';
  }

  return (
    <Card sx={styles} variant="outlined">
      <Tooltip title={`Loading...`} arrow>
        <CardContent
          sx={{ paddingTop: '4px', paddingBottom: '4px !important' }}
        >
          <Typography
            variant="subtitle2"
            gutterBottom
            align="center"
            sx={{ textTransform: 'capitalize' }}
          >
            {title || <Skeleton width={64} />}
          </Typography>
          <Stack direction="row" spacing={2}>
            <Typography variant="h5">
              <span>
                <Skeleton width={36} />
              </span>
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ display: 'flex', alignItems: 'flex-start' }}
            >
              <span>
                <Skeleton width={14} />
              </span>
              <span>
                <Skeleton width={27} />
              </span>
            </Typography>
          </Stack>
        </CardContent>
      </Tooltip>
    </Card>
  );
}
